// extracted by mini-css-extract-plugin
module.exports = {"ProseMirror":"InfoIcon_ProseMirror__3srqg","infoIcon":"InfoIcon_infoIcon__2ck-m"};